import React from "react";

interface DriverDefinitionListProps {
    driver: {
        name: string;
    }
}

const DriverDefinitionList = (props: DriverDefinitionListProps) => {

    const { driver } = props;

    if (!driver) {
        return null;
    }

    return (
        <dl>
            <dt>Driver Name</dt>
            <dd>{ driver.name ?? <>&mdash;</> }</dd>
        </dl>
    )

}

export default DriverDefinitionList;
